"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.approve = void 0;
const tslib_1 = require("tslib");
const axios_1 = require("axios");
const helpers_1 = require("../helpers");
const constants_1 = require("../constants");
const helpers_2 = require("./helpers");
/**
 * Approve Chat Request
 */
const approve = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { status = "Approved", 
    // sigType = 'sigType',
    account = null, signer = null, senderAddress, env = constants_1.default.ENV.PROD,
    // pgpPrivateKey = null,
     } = options || {};
    if (account == null && signer == null) {
        throw new Error(`At least one from account or signer is necessary!`);
    }
    const wallet = (0, helpers_2.getWallet)({ account, signer });
    const address = yield (0, helpers_2.getAccountAddress)(wallet);
    const API_BASE_URL = (0, helpers_1.getAPIBaseUrls)(env);
    const apiEndpoint = `${API_BASE_URL}/v1/chat/request/accept`;
    const body = (0, helpers_2.approveRequestPayload)(senderAddress, address, status);
    // const bodyToBeHashed = {
    //   fromDID: body.fromDID,
    //   toDID: body.toDID,
    //   status: body.status
    // }
    const connectedUser = yield (0, helpers_2.createUserIfNecessary)(wallet, env);
    // const hash = CryptoJS.SHA256(JSON.stringify(bodyToBeHashed)).toString()
    // const signature: string = await sign({
    //   message: hash,
    //   signingKey: connectedUser.privateKey!
    // });
    // const sigType = "pgp";
    // const verificationProof: string = sigType + ":" + signature;
    // body.verificationProof = verificationProof;
    return axios_1.default.put(apiEndpoint, body)
        .catch((err) => {
        console.error(`[Push SDK] - API ${exports.approve.name}: `, err);
        throw Error(`[Push SDK] - API ${exports.approve.name}: ${err}`);
    });
});
exports.approve = approve;
//# sourceMappingURL=approveRequest.js.map